import http from '@/components/services/http-common';
import formatter from '@/components/services/formatter';

export const get = (month='') => http.get('it/eventEnrollments?').then(res => {
  res.data.data= res.data.data.map(x => {
    x.createdAt = formatter.formatDate(x.createdAt, "HH:mm DD/MM/YYYY")
    return x
  })
  return res.data
})

export const remove = (detailid) => http.delete('it/eventEnrollments/'+detailid)

export const getDetail = (detailid) => http.get('employeeReviews/detail/'+detailid).then(res => res.data );

export const getDetailByEmployee = (detailid) => http.get('employeeReviews/detail/'+detailid, {
  params: {
    by: 'employee'}
}).then(res => res.data );

export const setFinal = (month) => http.post(`employeeReviews/final?month=${month}`);

export const removeFinal = (month) => http.delete(`employeeReviews/final?month=${month}`);

export const getFinal = (month) => http.get(`employeeReviews/final?month=${month}`).then(res => res.data );

export const getFinalSession = (year) => http.get(`employeeReviews/final/session/${year}`).then(res => res.data );

//ready section
export const getReady = (month) => http.get('employeeReviews/ready', {
  params: {
    month: month
  }
}).then(res => res.data );

export const setReady = (month) => http.post(`employeeReviews/ready?month=${month}`);

export const initReady = (month) => http.post(`employeeReviews/ready/init?month=${month}`);

export const generateReview = (month) => http.post(`employeeReviews/ready?month=${month}`);

export const changeConfirmedBy = (reviewId, employeeCode) => http.put(`employeeReviews/ready/${reviewId}/confirmedBy/${employeeCode}`);

export const changeApprovedBy = (reviewId, employeeCode) => http.put(`employeeReviews/review/${reviewId}/confirmedBy/${employeeCode}`);
